// src/lib/api/source.ts
export type DataSource = "local" | "http";

export function getDataSource(): DataSource {
  const forced = (process.env.NEXT_PUBLIC_DATA_SOURCE ?? "").toLowerCase();
  if (forced === "http") return "http";
  if (forced === "local") return "local";

  // In production on Pages, always use http through your own /api/* routes.
  return "http";
}

export function getApiBaseUrl(): string {
  // Client should never call backend directly.
  // Keep this for compatibility if other code expects it.
  return "";
}
